"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSummaryView = void 0;
const React = require("react");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const SalesOrderCustomerSummary_1 = require("../../atoms/SalesOrderCustomerSummary");
const CustomerSalesOrdersContext_1 = require("../../contexts/CustomerSalesOrdersContext");
const PendingContent_1 = require("../../../../../components/base/structure/PendingContent");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
/**
 * Displays the summary of a Sales Order, as per the end of a checkout process. It can
 * directly accept an order or fetch from the customer's current orders based on a routing
 * param.
 */
const SalesOrderSummaryView = (_a) => {
    var { salesOrder } = _a, rest = __rest(_a, ["salesOrder"]);
    const { allSalesOrders } = (0, useRequiredContext_1.useRequiredContext)(CustomerSalesOrdersContext_1.CustomerSalesOrdersContext);
    const [order, setOrder] = (0, react_1.useState)(salesOrder);
    if (!salesOrder) {
        const { orderId } = (0, react_router_dom_1.useParams)();
        (0, react_1.useEffect)(() => {
            if (!Array.isArray(allSalesOrders)) {
                return;
            }
            const order = allSalesOrders.find(o => o.salesOrderId === orderId);
            setOrder(order);
        }, [allSalesOrders]);
    }
    return (React.createElement(PendingContent_1.PendingContent, { check: order !== null }, order && React.createElement(SalesOrderCustomerSummary_1.SalesOrderCustomerSummary, Object.assign({ salesOrder: order }, rest))));
};
exports.SalesOrderSummaryView = SalesOrderSummaryView;
//# sourceMappingURL=index.js.map